module.exports = __webpack_public_path__ + "img/viz.a115f413.svg";